import React, {useEffect, useState} from 'react';
import QRCode from 'qrcode.react';

const GoogleAuthenticator = (props) => {
    const [secret, setSecret] = useState(props.value);
    const [user, setUser] = useState(props.user);
    const [totpCode, setTotpCode] = useState('');


    useEffect(() => {
        setSecret(props.value)
        setUser(props.user)
    }, [props.value]);

    const generateSecretKey = () => {
        // Generate a random secret key (base32-encoded)
        const newSecret = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
        setSecret(newSecret);
    };

    const generateTOTP = () => {
        // Use a TOTP library or algorithm to generate the current TOTP code based on the secret key
        // For simplicity, this example uses a dummy function
        const totp = generateDummyTOTP(secret);
        setTotpCode(totp);
    };

    const generateDummyTOTP = (secret) => {
        // Dummy function to generate a TOTP (replace with a proper TOTP algorithm)
        const currentTime = Math.floor(Date.now() / 1000);
        const timeStep = 30; // Time step in seconds
        const counter = Math.floor(currentTime / timeStep);
        return counter % 1000000; // Return a 6-digit TOTP code
    };

    return (
        <div>
            {/*<h2>Google Authenticator Activation</h2>*/}
            {/*<button onClick={generateSecretKey}>Generate Secret Key</button>*/}

                <div>
                    {/*<p>Secret Key: {secret}</p>*/}
                    <QRCode value={`otpauth://totp/${user}?secret=${secret}&issuer=İnternetOfis `} />
                    {/*<button onClick={generateTOTP}>Generate TOTP</button>*/}
                    {/*{totpCode && <p>TOTP Code: {totpCode}</p>}*/}
                </div>
        </div>
    );
};

export default GoogleAuthenticator;
